import { Size } from "web/types/examples/size";

export function getSizeText(size: Size): string {
    let sizeText = size.human_size;

    if (size.human_size !== size.raw_size) {
        sizeText = `${size.human_size} / ${size.raw_size}`;
    }

    return sizeText;
}
